import ErrorBoundary from "@/components/empty/ErrorBoundary";
import SpotlightArticle from "@/components/spotlightArticle";
import { Article } from "@/graphql/gql/graphql";
import { filterEmpty } from "@/utils/index";
import SportListColumn from "./SportListColumn";
import styles from "./sport.module.scss";

type SportArticlesContainerProps = {
  articles: Article[];
};

const SportArticlesContainer = ({ articles }: SportArticlesContainerProps) => {
  const [firstArticle, ...remainingArticles] = articles;
  return (
    <ErrorBoundary>
      <div className={styles.articleContainer}>
        <div>
          <SpotlightArticle
            image={firstArticle?.hero?.imageUrl?.url}
            title={firstArticle?.title}
            publishedOn={firstArticle?.firstPublishedAt}
            snippet={firstArticle?.description}
            link={`/${firstArticle?.slug}`}
            author={firstArticle?.author}
            origin="featured_sport_articles"
            sportName={firstArticle.sport.name}
            sportSlug={firstArticle.sport.slug}
            addBackground
            fullwidthMobileImage={false}
          />
        </div>
        <div className={styles.articleColumn}>
          <SportListColumn
            articles={filterEmpty(remainingArticles).slice(0, 6)}
            origin="featured_sport_articles"
          />
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default SportArticlesContainer;
